import React from "react"
import classnames from "classnames"
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined"

import {useUserContext} from "../../contexts/UserContext"

// Inline SVGs (rather than MUI icons) so the stroke width / size match
// the rest of the segmented control's typography. Match the sun/moon
// pair used elsewhere in the app for consistency.
const SunIcon = (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="4"/>
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>
    </svg>
)

const MoonIcon = (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
)

export const AppearanceSettings = () => {
    // The profile is the source of truth (profileState.theme is "Light" | "Dark").
    // Writing it via setProfileStateWithUpdate persists to the backend; UserContext
    // mirrors the change into the themeStore that drives every page's `data-theme`.
    const { profileState, setProfileStateWithUpdate } = useUserContext()
    const theme    = profileState?.theme === 'Light' ? 'light' : 'dark'
    const setTheme = (mode) => setProfileStateWithUpdate({ theme: mode === 'light' ? 'Light' : 'Dark' })

    return (
        <div className={'profile-panel AppearanceSettings'}>
            <div className={'panel-header'}>
                <div className={'panel-title'}>
                    <PaletteOutlinedIcon/>
                    Appearance
                </div>
            </div>
            <div className={'panel-body'}>
                <div className={'setting-row'}>
                    <span className={'setting-row-label'}>Theme</span>

                    <div className={'theme-toggle-group'} role={'tablist'} aria-label={'Theme'}>
                        <button
                            type={'button'}
                            role={'tab'}
                            aria-selected={theme === 'light'}
                            className={classnames('theme-option', {active: theme === 'light'})}
                            onClick={() => setTheme('light')}
                        >
                            <SunIcon/>
                            Light
                        </button>
                        <button
                            type={'button'}
                            role={'tab'}
                            aria-selected={theme === 'dark'}
                            className={classnames('theme-option', {active: theme === 'dark'})}
                            onClick={() => setTheme('dark')}
                        >
                            <MoonIcon/>
                            Dark
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
